import { render, staticRenderFns } from "./StatsTabItem.vue?vue&type=template&id=6a169a78&"
import script from "./StatsTabItem.vue?vue&type=script&lang=js&"
export * from "./StatsTabItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports